// src/services/condominosService.js

import api from "./api";
const condominosService = {
  listar:         (p={}) => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/condominos?${qs}`); },
  stats:          ()     => api("GET", "/condominos/stats"),
  buscarPorId:    (id)   => api("GET", `/condominos/${id}`),
  listarSelect:   (idCondominio) => api("GET", `/condominos/select${idCondominio?`?idCondominio=${idCondominio}`:""}`),
  criar:          (data) => api("POST", "/condominos", data),
  atualizar:      (id, data) => api("PUT", `/condominos/${id}`, data),
  deletar:        (id)   => api("DELETE",`/condominos/${id}`),
  alterarStatus:  (id, inativo) => api("PATCH", `/condominos/${id}/status`, { inativo }),
  listarUnidades: (id)   => api("GET", `/condominos/${id}/unidades`),
  verificarCpf:   (cpf_cnpj, excludeId) => {
    const qs = new URLSearchParams({ cpf_cnpj });
    if (excludeId) qs.append("excludeId", excludeId);
    return api("GET", `/condominos/verificar-cpf?${qs}`);
  },
  search:         (q)   => api("GET", `/condominos/search?q=${encodeURIComponent(q||"")}`),

  // (4) Documentos
  listarDocumentos:  (id)             => api("GET",    `/condominos/${id}/documentos`),
  uploadDocumento:   (id, data)       => api("POST",   `/condominos/${id}/documentos`, data),
  baixarDocumento:   (id, docId)      => api("GET",    `/condominos/${id}/documentos/${docId}`),
  excluirDocumento:  (id, docId)      => api("DELETE", `/condominos/${id}/documentos/${docId}`),

  // (6) Aniversariantes
  aniversariantes:   (mes)            => api("GET",    `/condominos/aniversariantes${mes?`?mes=${mes}`:""}`),

  // (8) Importação CSV/Excel
  importar:          (data)           => api("POST",   "/condominos/importar", data),

  // (10) Ficha PDF
  fichaPdf:          (id)             => api("GET",    `/condominos/${id}/ficha-pdf`),

  // (11) LGPD
  lgpdAceitar:       (id, versao)     => api("POST",   `/condominos/${id}/lgpd/aceitar`, { versao }),
  lgpdRevogar:       (id)             => api("POST",   `/condominos/${id}/lgpd/revogar`),
  lgpdHistorico:     (id)             => api("GET",    `/condominos/${id}/lgpd/historico`),

  // Acesso ao Portal — gerencia o usuário do tipo "Condomino" pela ficha do condômino
  portalAcessoStatus:    (id) => api("GET",    `/condominos/${id}/portal-acesso`),
  criarPortalAcesso:     (id) => api("POST",   `/condominos/${id}/portal-acesso`),
  resetarSenhaPortal:    (id) => api("PATCH",  `/condominos/${id}/portal-acesso/resetar-senha`),
  reenviarEmailPortal:   (id, senha) => api("POST", `/condominos/${id}/portal-acesso/reenviar-email`, { senha }),
  revogarPortalAcesso:   (id) => api("PATCH",  `/condominos/${id}/portal-acesso/revogar`),
  reativarPortalAcesso:  (id) => api("PATCH",  `/condominos/${id}/portal-acesso/reativar`),
  excluirPortalAcesso:   (id) => api("DELETE", `/condominos/${id}/portal-acesso`),
};

export default condominosService;
